<template>
    <div class="mb-5">
        <h1 class="page-title">Gérer les nouveautés</h1>
    </div>
    <div class="flex justify-end">
        <Button
            label="Ajouter une nouveauté"
            @click="router.push({ name: 'addNews' })"
            icon="pi pi-plus"
            class="button-add"
        />
    </div>
    <div class="card">
        <DataTable
            lazy
            :value="tableData"
            :paginator="true"
            :rows="rows"
            removableSort
            :loading="isLoading"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 100]"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
            @page="onPaginate($event)"
            @sort="onSort($event)"
        >
            <template #header>
                <div class="flex flex-row flex-nowrap card-header border-0">
                    <div class="flex card-toolbar w-full">
                        <div class="w-full">
                          <span class="p-input-icon-left w-10/12">
                              <i class="pi pi-search" />
                              <InputText type="text" class="w-9/12" v-model="criteria" placeholder="Rechercher..." @keyup.enter="onSearchInputDt()" />
                          </span>
                        </div>
                    </div>
                    
                    
                </div>
                <div class="flex w-full mt-6">
                    <div class="flex justify-center ml-auto">
                        <p>Nombre total de nouveautés : {{ totalRecords }}</p>
                    </div>
                </div>
                
                
            </template>

            <div class="card-body pt-0">
                <Column field="vignette" header="Miniature">
                    <template #body="slotProps">
                        <img v-if="slotProps.data.imageWeb" :src="slotProps.data.imageWeb.url" class="w-14" />
                    </template>
                </Column>
                <Column field="position" header="position" sortable>
                    <template #body="slotProps">
                        <span> {{ slotProps.data.position }} </span>
                    </template>
                </Column>
                <Column field="action" header="Action">
                    <template #body="slotProps">
                        <div class="d-flex flex-row">
                            <Button size="small" icon="pi pi-pencil" class="p-edition"
                                    style="margin-right: 0.5em" title="Éditer"
                                    @click="router.push({ name: 'editNews', params: { uuid: slotProps.data.uuid } })">
                            </Button>
                            <Button size="small" icon="pi pi-trash" class="p-button-danger"
                                    style="margin-right: 0.5em" title="supprimer" @click="onDelete(slotProps.data)">
                            </Button>
                        </div>
                    </template>
                </Column>
            </div>
            <template #empty>Aucun produit ne correspond à votre recherche</template>
        </DataTable>
    </div>
</template>
<script setup lang="ts">
import DataTable from "primevue/datatable";
import { ref, onMounted } from 'vue';
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Column from "primevue/column";
import router from "@/router";
import {deleteNews, fetchNews} from "@/_services/homepage/news";
import {INews} from "@/models/homepage/INews";
import swal from "@/_helpers/swal";
const news = Array<INews>();
const tableData = ref<Array<INews>>(news);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const addLoading = ref(false);

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchNews(
        itemsPerPage,
        page,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
    isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const onSearchInputDt = () => {
    if (0 === criteria.value.length || 3 <= criteria.value.length) {
        populateDatatable(
            rows.value,
            page.value,
            "" != criteria.value ? criteria.value : ""
        );
    }
}

const onDelete = (data: INews) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer ?")
        .then((result) => {
            if (result.isConfirmed) {
                deleteNews(data.uuid).then(() => {
                    swal.success("succés !", "Suppression effectuée avec succès");
                    populateDatatable(
                        rows.value,
                        page.value,
                        "" != criteria.value ? criteria.value : ""
                    );
                });
            }
        });
};
</script>
